"use client";

import { useTranslations } from "next-intl";

import type { ArticleMeta } from "@/integrations/articles";
import { cn } from "@/lib/utils/cn";

import { ArticleCard } from "./ArticleCard";

interface RelatedArticlesProps {
  articles: ArticleMeta[];
  className?: string;
}

export function RelatedArticles({ articles, className }: RelatedArticlesProps) {
  const t = useTranslations("pages.articles");

  if (articles.length === 0) {
    return null;
  }

  const limited = articles.slice(0, 3);

  return (
    <section className={cn("space-y-4", className)}>
      <h2 className="font-heading text-2xl font-semibold">{t("relatedHeading")}</h2>
      <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {limited.map((article) => (
          <li key={`${article.locale}-${article.slug}`}>
            <ArticleCard article={article} />
          </li>
        ))}
      </ul>
    </section>
  );
}
